import Hearing from "@mui/icons-material/Hearing";
import Home from "@mui/icons-material/Home";
import Language from "@mui/icons-material/Language";
import PermMedia from "@mui/icons-material/PermMedia";
import PieChartOutlineRounded from "@mui/icons-material/PieChartOutlineRounded";
import Send from "@mui/icons-material/Send";
import Timeline from "@mui/icons-material/Timeline";
import { Badge } from "@mui/material";
import type { FC } from "react";
import { useTranslation } from "react-i18next";
import { usePermissions } from "../../../../../server/auth/use-permissions";
import { useAnalyticsPerms } from "../../../../employees/hooks/use-analytics";
import { BetaBadge } from "../../../../generic/components/beta/beta-badge";
import { useAccountLimit } from "../../../../generic/hooks/use-account-limit";
import { useIsActive } from "../hooks/use-is-active";
import { Item } from "../item";
import { Programs } from "../programs";
import { Section } from "../section";

export const NavOptions: FC = () => {
  const { t } = useTranslation();

  const isActive = useIsActive();
  const perms = usePermissions();

  const analyticsPerms = useAnalyticsPerms();
  const showRecipientActivityPage = perms.super_admin;
  const { data: listenEntitlement } = useAccountLimit("listen_entitlement");
  return (
    <Section>
      <>
        <Item
          title={t("Home")}
          icon={<Home />}
          onClick={{ type: "href", value: "/moments/dashboard" }}
          active={isActive("/moments/dashboard")}
        />
        <Item
          title={t("Content Library")}
          icon={<PermMedia />}
          onClick={{ type: "href", value: "/content-library" }}
          active={isActive("/content-library")}
        />
        <Item
          title={t("Discover")}
          icon={<Language />}
          onClick={{ type: "href", value: "/discover" }}
          active={isActive("/discover", true)}
        />
        <Item
          title={t("Listen")}
          icon={<Hearing />}
          onClick={{ type: "href", value: "/listen" }}
          active={isActive("/listen", true)}
          label={
            <Badge
              color="secondary"
              badgeContent={listenEntitlement === "Pro" ? "Beta" : "New"}
              overlap="circular"
              sx={{
                display: "inline",
                "& .MuiBadge-badge": {
                  transform: "unset",
                  position: "unset",
                },
              }}
            />
          }
        />
        <Programs />
        <Item
          title={t("Sent Communications")}
          icon={<Send />}
          onClick={{ type: "href", value: "/moments/history" }}
          active={isActive("/moments/history")}
        />
        {analyticsPerms.length > 0 && (
          <BetaBadge overlap="circular" sx={{ "& .MuiBadge-badge": { top: "18px" } }}>
            <Item
              title={t("Analytics")}
              icon={<PieChartOutlineRounded />}
              onClick={{ type: "href", value: "/analytics" }}
              active={isActive("/analytics")}
            />
          </BetaBadge>
        )}

        {showRecipientActivityPage === true && (
          <Item
            title={t("Recipient Activity")}
            icon={<Timeline />}
            onClick={{ type: "href", value: "/recipient-activity" }}
            active={isActive("/recipient-activity", true)}
          />
        )}
      </>
    </Section>
  );
};
